import { getNestedValue } from '@/utils/object.js'

export default function createSensorConfigEntity(rawData) {
  return {
    code: getNestedValue(rawData, ['code']),
    color: getNestedValue(rawData, ['couleur', 'color']),
    name: getNestedValue(rawData, ['nom', 'name']),
    number: getNestedValue(rawData, ['num', 'number']),
    work: getNestedValue(rawData, ['travail', 'work']),
    type: getNestedValue(rawData, ['type']),
    active: getNestedValue(rawData, ['actif', 'active']),
  }
}
